
<div class="menu-container" [ngStyle]="{'background-color': utilService.trainerMode ? 'white':'#EFEFEF' }">
  <div class="spinner"  *ngIf="!utilService.promptDataLoaded"> <app-spinner ></app-spinner></div>
  <div class="token-container">
    Tokens: {{utilService.token}}
  </div>
  <div class="version-container">
  <div class="schema" mat-button disabled [matMenuTriggerFor]="schema">
    <div class="schema-data">
     <ion-label>Version {{utilService.selectedVersion}}</ion-label>
     </div>
     <ion-img src="assets/images/arrow_down.svg" class="arrow-img"></ion-img>
   </div>
   <mat-menu #schema="matMenu" >
   <div class="version-containers">
    <button mat-menu-item *ngFor="let item of [].constructor(utilService.currentVersion); let i = index" 
    (click)="selectSchema(i + 1)" class="menu-item">
<div class="select-schema">
<span>version {{i + 1}}</span>
</div>
</button>
</div>
  </mat-menu>
  <div class="semantic-info" >
    <app-process-type [processTypes]="processTypes" *ngIf="utilService.promptDataLoaded" ></app-process-type>
  
  </div>
  </div>
 
 <div class="prompt-container">
  <div  *ngFor="let item of utilService.updatedPromptDetails">
  <div class="question-container" *ngIf="item.details!=''" >
   
    <div class="header" >
      <ion-label class="details-text">{{item.type}}</ion-label>
        <div class="edit-btn" (click)="editBlock(item.type,item.details,item.readOnly)" *ngIf="!item.isEdit &&utilService.detailsEdit &&!item.readOnly  && !item.editDisabled">
          <ion-img src="assets/images/edit.svg"></ion-img>

          <ion-label [ngStyle]="{'color': item.editDisabled ?  '#C1C1C1':'#F89229'}">Edit</ion-label>
        </div>
        <div class="edit-btn"  *ngIf="!item.isEdit  && item.editDisabled && !item.readOnly">
          <ion-img src= "assets/images/Draw.svg"></ion-img>

          <ion-label [ngStyle]="{'color': item.editDisabled ?  '#C1C1C1':'#F89229'}">Edit</ion-label>
        </div>
        <div class="expand-btn" *ngIf="!utilService.detailsEdit || item.readOnly"  (click)="openEditPromptMenu(item.details,item.type,item.readOnly)">
          <ion-img src="assets/images/expand.svg"></ion-img>
        </div>
       
     
    </div>
   

     <div class="content" ellipsis [ellipsis-content]="item.details"></div>
     <div class="err-container" *ngIf="item.errMsg!=''">
      {{item.errMsg}}
    </div>
     <!-- <ion-input [(ngModel)]="utilService.generatedQuestion" *ngIf="item.type==='Question'" [readonly]="!item.isEdit" [ngStyle]="{'border-bottom':item.isEdit ? '1px solid #EFEFEF':'none' }"></ion-input> -->
  </div>

 </div>
 <ion-modal #modal [isOpen]="isEditPromptOpen" backdropDismiss="false">
  <ng-template>
   <app-edit-prompt [editable]="isContentEditable"
   [content]="content" 
   [promptType]="promptType"
   (contentChange)="closeEditPromptMenu($event)"></app-edit-prompt>
  </ng-template>
</ion-modal>
  </div>
</div>
